const resource = 'orders'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },
  get(id, params) {
    return $axios.$get(`/${resource}/${id}`, { params })
  },
  userAgent(id, params) {
    return $axios.$patch(`/${resource}/${id}/user_info`, params)
  },
  setAnalytics(id, params) {
    return $axios.$patch(`/${resource}/${id}/analytics`, params)
  },
  delete(id, params) {
    return $axios.$delete(`/${resource}/${id}`, { params })
  },
  applyCode(id, params) {
    return $axios.$patch(`/${resource}/${id}/apply_code_with_name`, params)
  },
  assignShippingAddress(id, params) {
    return $axios.$patch(`/${resource}/${id}/assign_shipping_address`, params)
  },
  assignBillingAddress(id, params) {
    return $axios.$patch(`/${resource}/${id}/assign_billing_address`, params)
  },
  getShippingMethods(id, params) {
    return $axios.$get(
      `/${resource}/${id}/shipping_method_ranges/available`,
      params
    )
  },
  getShippingMethodRelay(id, identifier, params) {
    return $axios.$post(
      `/${resource}/${id}/shipping_methods/${identifier}/list`,
      params
    )
  },
  assignShippingMethod(id, identifier, shipping_method_range, params) {
    return $axios.$patch(
      `/${resource}/${id}/shipping_methods/${identifier}/${shipping_method_range}`,
      params
    )
  },
  saveCustomerInstruction(id, params) {
    return $axios.$patch(`/${resource}/${id}/customer_instructions`, params)
  },
  getPaymentMethods(id, params) {
    return $axios.$get(`/${resource}/${id}/payment_methods/available`, params)
  },
  getPaypalLink(id, params) {
    return $axios.$post(
      `/${resource}/${id}/payment_methods/paypal/paymentLink`,
      params
    )
  },
  getOneyLink(id, params) {
    return $axios.$post(
      `/${resource}/${id}/payment_methods/payplug_oney/paymentLink`,
      params
    )
  },
  getOneySimulation(id) {
    return $axios.$get(
      `/${resource}/${id}/payment_methods/payplug_oney/preview`
    )
  },
  getPayplugStatus(id, params) {
    return $axios.$get(
      `/${resource}/${id}/payment_methods/payplug/status`,
      params
    )
  },
  choosePaymentMethod(id, params) {
    return $axios.$patch(`/${resource}/${id}/choose_payment_method`, params)
  },
  assignPaymentMethod(id, identifier, params) {
    return $axios.$patch(
      `/${resource}/${id}/payment_methods/${identifier}/assign`,
      params
    )
  },
  saveOrder(id, params) {
    return $axios.$post(`/${resource}/${id}/save`, params)
  },
  useOrder(id, params) {
    return $axios.$post(`/${resource}/${id}/select`, params)
  },
  associateVehicles(id, params) {
    return $axios.$patch(`/${resource}/${id}/associate_vehicles`, params)
  },
  setSourceVehicle(id, params) {
    return $axios.$patch(`/${resource}/${id}/source_vehicle`, params)
  },
  setInstagramStoriesOpened(id, params) {
    return $axios.$patch(`/${resource}/${id}/instagram_stories_opened`, params)
  },
  sendCartByEmail(params) {
    return $axios.$post('/v2/cart/email', params)
  },
  optOutOfCartReminders(token) {
    return $axios.$post('/v2/cart/reminders/opt-out', { token })
  },
  fetchLightingSuggestions(id) {
    return $axios.$get(`/v2/cart/${id}/lighting-suggestions`)
  },
  fetchDeliveryOptions(id) {
    return $axios.$get(`/v2/cart/${id}/delivery-options`)
  },
  addVehicle(id, params) {
    return $axios.$post(`/${resource}/${id}/vehicles`, params)
  },
  removeVehicle(id, vehicleId) {
    return $axios.$delete(`/${resource}/${id}/vehicles/${vehicleId}`)
  },
  replaceVehicle(id, vehicleId, params) {
    return $axios.$patch(`/${resource}/${id}/vehicles/${vehicleId}`, params)
  },

  getProductsFromReviewToken(token, params) {
    return $axios.get(`/${resource}/review_token/${token}`, params)
  },

  fetchAccountOrders(params) {
    return $axios.$get('/v2/account/orders', { params })
  },

  fetchAccountOrder(orderId) {
    return $axios.$get(`/v2/account/orders/${orderId}`)
  },

  fetchAccountSavedCarts() {
    return $axios.$get('/v2/account/saved-carts')
  },

  fetchAccountReturnableOrders() {
    return $axios.$get('/v2/account/returnable-orders')
  },

  fetchAccountReviewEligibleOrder(reviewToken) {
    return $axios.$get(`/v2/account/reviews/eligible/${reviewToken}`)
  },

  fetchAccountReviewEligibleOrderVariant(reviewToken, orderVariantId) {
    return $axios.$get(
      `/v2/account/reviews/eligible/${reviewToken}/${orderVariantId}`
    )
  },

  getServiceName: name => 'orderService',
})
